import { render, staticRenderFns } from "./DemandServiceTasks.vue?vue&type=template&id=ca359304&scoped=true&"
import script from "./DemandServiceTasks.vue?vue&type=script&lang=js&"
export * from "./DemandServiceTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca359304",
  null
  
)

export default component.exports